export default "__VITE_ASSET__95cf3951__"